import { RefObject } from 'react';

import { Action } from '@rbi-ctg/frontend';

export interface IAddressInputState {
  forceHidePredictions: boolean;
  focusedIndex: number;
  address: string;
  skipPredictions: boolean;
}

export enum ActionType {
  ADDRESS_CHANGED = 'ADDRESS_CHANGED',
  ADDRESS_CHANGED_PROP = 'ADDRESS_CHANGED_PROP',
  ON_CLICK_OUTSIDE = 'ON_CLICK_OUTSIDE',
  PRESSED_DOWN = 'PRESSED_DOWN',
  PRESSED_ESCAPE = 'PRESSED_ESCAPE',
  PRESSED_UP = 'PRESSED_UP',
  SELECTED_PREDICTION = 'SELECTED_PREDICTION',
  USER_FOCUSED = 'USER_FOCUSED',
  USER_BLURRED = 'USER_BLURRED',
}

export type FocusRefs = [RefObject<HTMLInputElement | null>, ...RefObject<HTMLButtonElement>[]];

export type Actions =
  | Action<
      ActionType.ADDRESS_CHANGED | ActionType.ADDRESS_CHANGED_PROP | ActionType.SELECTED_PREDICTION,
      string
    >
  | Action<ActionType.ON_CLICK_OUTSIDE, boolean>
  | Action<ActionType.PRESSED_DOWN, FocusRefs>
  | Action<
      | ActionType.USER_FOCUSED
      | ActionType.PRESSED_UP
      | ActionType.PRESSED_ESCAPE
      | ActionType.USER_BLURRED
    >;
